import { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PaginadorProps } from '../../interfaces/globalInterfaces';
import './Paginador.scss';

export const Paginador = ({
  totalRegistros,
  paginaCambiada,
  tamanoPagina,
}: PaginadorProps) => {
  const [pagActual, setPagActual] = useState<number>(0);
  const primerRegistroActual = () => {
    return totalRegistros ? pagActual * tamanoPagina + 1 : 0;
  };
  const ultimoRegistroActual = () => {
    const inicio = pagActual * tamanoPagina;
    if (inicio + tamanoPagina > totalRegistros) {
      return totalRegistros
        ? inicio + (totalRegistros - primerRegistroActual()) + 1
        : 0;
    }
    return inicio + tamanoPagina;
  };
  const irPagina = (pag) => {
    setPagActual(pag);
    paginaCambiada(pag);
  };
  const ultimaPagina = () => {
    let pagina = Math.floor(totalRegistros / tamanoPagina);
    return tamanoPagina * pagina !== totalRegistros ? pagina : pagina - 1;
  };
  return (
    <>
      <div className="paginador px-4">
        <div className="info-paginas">
          {primerRegistroActual()} - {ultimoRegistroActual()} de{' '}
          {totalRegistros}
        </div>
        <div className="navegacion-paginas">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Primera Página</Tooltip>}
          >
            <Button
              variant="outline-light btnflechas"
              onClick={() => irPagina(0)}
              disabled={pagActual === 0}
            >
              <div className="material-icons">first_page</div>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Página Anterior</Tooltip>}
          >
            <Button
              variant="outline-light btnflechas"
              disabled={pagActual === 0}
              onClick={() => irPagina(pagActual - 1)}
            >
              <div className="material-icons">chevron_left</div>
            </Button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Página Siguiente</Tooltip>}
          >
            <Button
              variant="outline-light btnflechas"
              disabled={ultimoRegistroActual() >= totalRegistros}
              onClick={() => irPagina(pagActual + 1)}
            >
              <div className="material-icons">chevron_right</div>
            </Button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Última Página</Tooltip>}
          >
            <Button
              variant="outline-light btnflechas"
              disabled={pagActual === ultimaPagina()}
              onClick={() => irPagina(ultimaPagina())}
            >
              <div className="material-icons">last_page</div>
            </Button>
          </OverlayTrigger>
        </div>
      </div>
    </>
  );
};
